<template>
  <div class="select-room" v-loading.fullscreen.lock="fullLoading">
    <step-breadcrumb :stepIndex="2"/>
    <div class="block-head" v-loading="!hotel_info" v-if="!isEdit">
      <div class="basic-info">
        <p>{{ $t('Trip Basic Information') }}{{ $t(':') }}</p>
        <div class="info-content">
          <div class="hotel-info">
            <div class="hotel-img">
              <img :src="hotel_info.img" :alt="hotel_info.name">
            </div>
            <div class="texts">
              <span class="label">{{ $t('Hotel Selection') }}{{ $t(':') }}</span>
              <strong>{{ hotel_info.name }}</strong>
            </div>
          </div>
          <div class="duration">
            <div class="texts">
              <span class="label">{{ $t('Duration') }}{{ $t(':') }} {{ $t('(') }}{{
                  hotel_info.day_number
                }} {{ $t('Nights') }}{{ $t(')') }}</span>
              <strong>{{ hotel_info.arrival_date_format }} {{ $t('to') }}
                {{ hotel_info.departure_date_format }}</strong>
            </div>
          </div>
          <div class="room-guests">
            <div class="texts">
              <span class="label">{{ $t('Rooms & Guests') }}{{ $t(':') }}</span>
              <strong>{{
                  $t('{0}Rooms,{1}Adults,{2}Children Per Room',
                    [hotel_info.rooms, hotel_info.adults, hotel_info.children])
                }}</strong>
            </div>
            <div class="action">
              <el-button type="primary" @click="edit"><i class="el-icon-edit"/>{{ $t('EDIT') }}</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="room-selections" v-if="selects.length">
        <p>{{ $t('Room Selections') }}{{ $t(':') }}</p>
        <table class="pc">
          <tbody v-for="(room,index) of selects" :key="index">
          <tr class="tr-head">
            <td>
              <span class="room-index">{{ $t('room') }} {{ index + 1 }}</span>
            </td>
            <td colspan="3"></td>
            <td>
              <el-button class="el-icon-delete" @click="remove(index)">{{ $t('Remove') }}</el-button>
            </td>
          </tr>
          <tr class="tr-title tr-item">
            <td>{{ room.RoomTypeCate }} - {{ room.name }}</td>
            <td>{{ hotel_info.adults }} {{ $t('Adults') }} {{ hotel_info.children }} {{ $t('Children') }}</td>
            <td>{{ hotel_info.day_number }} {{ $t('Nights') }}</td>
            <td>{{ room.TotalPrice | formatMoney($t(currency)) }} x {{ hotel_info.day_number }}</td>
            <td>{{ ((getNum(room.TotalPrice) * hotel_info.day_number)) | formatMoney($t(currency)) }}</td>
          </tr>
          <tr v-for="(select,selectIndex) of room.selects" :key="selectIndex" class="tr-item">
            <td>{{ select.name }}</td>
            <td></td>
            <td>{{ select.qty }} {{ select.unit }}</td>
            <td>{{ select.average_price | formatMoney($t(currency)) }} x {{ select.qty }}</td>
            <td>{{ (select.average_price * select.qty) | formatMoney($t(currency)) }}</td>
          </tr>
          <tr class="tr-total">
            <td colspan="5"><span
              class="total">{{ $t('Total') }}{{ $t(':') }} {{
                (totals[index][room.selects.length + 1]) | formatMoney($t(currency))
              }}</span></td>
          </tr>
          <tr class="tr-margin">
            <td colspan="5"></td>
          </tr>
          </tbody>
        </table>
        <ul class="mop">
          <li v-for="(room,index) of selects" :key="index" class="room-items">
            <div class="action-box">
              <span>{{ $t('room') }} {{ index + 1 }}</span>
              <el-button class="el-icon-delete" @click="remove(index)">{{ $t('Remove') }}</el-button>
            </div>
            <div class="table-content">
              <ol>
                <li class="room">
                  <div>{{ room.RoomTypeCate }} - {{ room.name }}</div>
                  <div>{{ hotel_info.adults }} {{ $t('Adults') }}{{ $t(',') }} {{ hotel_info.children }}
                    {{ $t('Children') }}
                  </div>
                  <div>{{ hotel_info.day_number }} {{ $t('Nights') }}</div>
                  <div>{{ room.TotalPrice | formatMoney($t(currency)) }} x {{ hotel_info.day_number }}</div>
                  <div>{{ ((getNum(room.TotalPrice) * hotel_info.day_number)) | formatMoney($t(currency)) }}</div>
                </li>
                <li v-for="(select,selectIndex) of room.selects" :key="selectIndex" class="packages">
                  <div>{{ select.name }}</div>
                  <div>{{ select.qty }} {{ select.unit }}</div>
                  <div>{{ select.average_price | formatMoney($t(currency)) }} x {{ select.qty }}</div>
                  <div>{{ (select.average_price * select.qty) | formatMoney($t(currency)) }}</div>
                </li>
              </ol>
            </div>
            <span
              class="total">{{ $t('Total') }}{{ $t(':') }} {{
                (totals[index][room.selects.length + 1]) | formatMoney($t(currency))
              }}</span>
          </li>
        </ul>
      </div>

      <div class="checkout-wrapper" v-show="selects.length >= 1">
        <div class="checkout-colum">
          <span class="grand-total">{{ $t('Select Grand Total') }}{{ $t(':') }}&nbsp;{{ grandTotal | formatMoney($t(currency)) }}</span>
        </div>
        <div class="checkout-colum">
          <el-button type="primary" plain @click="addRoom" :disabled="Number(hotel_info.rooms) >= 9">{{ $t('ADD ROOM') }}</el-button>
          <el-button type="primary" @click="checkout">{{ $t('PAYMENT') }}</el-button>
        </div>
      </div>

      <div class="filter-sort" v-show="selects.length !== +hotel_info.rooms">
        <div class="filter-by">
          <label for="filter-by">{{ $t('Filter By') }}{{ $t(':') }}</label>
          <select id="filter-by">
            <option value="">Amenities</option>
          </select>
        </div>

        <div class="sort-by">
          <el-button
            type="primary"
            class="by-room"
            :class="{'active':group_by==='cate'}"
            @click="groupBy('cate')">{{ $t('Group by Room') }}
          </el-button>
          <el-button
            type="primary"
            class="by-rate"
            :class="{'active':group_by==='rate'}"
            @click="groupBy('rate')">{{ $t('Group by Rates') }}
          </el-button>
        </div>
      </div>

    </div>

    <div class="hotel-edit" v-if="isEdit">
      <advance-search/>
    </div>

    <div class="block" :class="group_by" v-show="selects.length !== +hotel_info.rooms">
      <div class="state">
        <span class="label">{{ $t('Search Results') }}{{ $t(':') }} </span>
        <span>{{ $t('Selection for Room {s}', {s: selects.length + 1}) }}</span>
      </div>

      <el-collapse v-if="group_by==='cate'" v-model="collapse">
        <template v-for="(group,groupKey,groupIndex) of room_info">
          <el-collapse-item
            v-if="hasAvailableCategoryGroup(group)"
            class="room-group"
            :key="groupIndex"
            :name="groupIndex">
          <template slot="title">
            <div class="group-view" @click.stop>
              <div class="group-img" @click.stop="showGallery(group.imgs,
                    `${hotel_info.name}${$t(',')} ${group.group_name}`,group.desc)">
                <img v-if="group.imgs.length" :src="group.imgs.find(element => element.is_main).url"
                     alt="room image">
                <span v-if="group.imgs.length" class="gallery-icon">
                  {{ $t('Gallery') }}
                </span>
              </div>
              <div class="group-introduction">
                <p class="group-name"><span>{{ group.group_name }}</span></p>
                <p v-html="group.desc" class="cms-style"></p>

                <span class="lowest" @click="viewAll($event,groupIndex)"
                      v-html="$t('From avg. {s} per night',{s:`<span>${formatMoney(group.lower,$t(currency))}</span>`})"></span>
              </div>
              <div class=view-all @click="viewAll($event,groupIndex)">{{ $t('View All') }} »</div>
            </div>
          </template>
          <template v-for="(rate,rateKey,rateIndex) of group.rate">
            <div
              v-if="hasAvailableRooms(rate.room_type, rateKey)"
              class="room-rate"
              :key="rateIndex">
            <div class="rate-actions">
              <div class="rate-info">
                <p class="rate-name">{{ rate.rate_info.name }}</p>
                <div class="rate-desc cms-style" v-html="rate.rate_info.desc"></div>
                <el-button
                  @click="showPolicy(rate.rate_info.cancel_rule.remark)">
                  {{ $t('Cancellation Policy') }} »
                </el-button>
              </div>
              <div class="room-types">
                <ul>
                  <template v-for="(type,typeIndex) of rate.room_type">
                    <li :key="typeIndex" v-if="!isRoomInventoryFull(type, rateKey)">
                      <div class="img-content" v-if="type.img">
                        <img :src="type.img" alt="room image">
                      </div>

                      <div class="texts">
                        <strong>{{ type.name }}</strong>
                        <p>{{ $t('{s} per night', {s: formatMoney(type.TotalPrice, $t(currency))}) }}</p>
                      </div>

                      <el-button
                        :disabled="isEdit"
                        type="primary"
                        :class="{selected:type===rate.activeRoom}"
                        @click="select(type,{groupKey,rateKey})"
                        v-text="type===rate.activeRoom?$t('SELECTED'):$t('SELECT')"/>
                    </li>
                  </template>
                </ul>

              </div>
            </div>
            <div class="trip" v-if="rate.selects.length" :id="groupKey+rateKey">
              <p>{{ $t('Upgrade your trip') }}!</p>

              <div class="shuffling">
                <el-carousel arrow="always" :autoplay="false" indicator-position="none">
                  <el-carousel-item v-for="(page,pageIndex) in Math.ceil(rate.selects.length/shufflingQty )"
                                    :key="pageIndex">
                    <div class="page" :index="pageIndex">
                      <div class="additional-item"
                           v-for="(additional,addIndex) of rate.selects.slice(pageIndex*shufflingQty,(pageIndex+1)*shufflingQty)"
                           :key="addIndex">
                        <div class="additional-img">
                          <img :src="additional.image" alt="additional image">
                        </div>
                        <span class="additional-name">{{ additional.name }}</span>
                        <div class="price-box">
                          <span class="price">+ {{ additional.average_price | formatMoney($t(currency)) }}</span> /
                          {{ additional.unit }}
                        </div>
                        <div class="additional-action">
                          <select v-model="additional.qty">
                            <option :value="0">- {{ $t('Please Select') }} -</option>
                            <option :value="n" v-for="n of 7" :key="n">{{ n }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>

                <div class="actions">
                  <el-button type="primary" class="action-add"
                             @click="addPackage(rate.selects,rate.activeRoom,rateKey)">
                    {{ $t('ADD') }}
                  </el-button>
                  <el-button
                    type="primary"
                    class="action-no" plain
                    @click="addToCart(rate.activeRoom,rateKey)">
                    {{ $t('NO THANKS!') }}
                  </el-button>
                </div>

              </div>

            </div>
            </div>
          </template>
          </el-collapse-item>
        </template>
      </el-collapse>


      <ul v-if="group_by==='rate'">
        <template v-for="(rate,rateKey,rateIndex) of room_info">
          <li
            v-if="hasAvailableRate(rate, rateKey)"
            class="room-rate"
            :key="rateIndex">
          <div class="rate-info">
            <p class="rate-name">{{ rate.rate_info.name }}</p>
            <p class="rate-describe cms-style" v-html="rate.rate_info.desc"></p>
            <el-button
              class="cancel"
              @click="showPolicy(rate.rate_info.cancel_rule.remark)">
              {{ $t('Cancellation Policy') }} »
            </el-button>
          </div>
          <el-collapse class="group-list" v-model="collapse[rateIndex]">
            <template v-for="(group,groupKey,groupIndex) of rate.group">
              <el-collapse-item
                v-if="hasAvailableRateGroup(group, rateKey)"
                :key="groupIndex"
                :name="groupIndex">
              <template slot="title">
                <div class="group-view" @click.stop>
                  <div class="group-img" @click.stop="showGallery(group.group_info.imgs,
                        `${hotel_info.name}${$t(',')} ${rate.rate_info.name}${$t(',')} ${group.group_info.group_name}`,group.group_info.desc)">
                    <img alt="group image"
                         v-if="group.group_info.imgs.length"
                         :src="group.group_info.imgs.find(element => element.is_main).url">
                    <span v-if="group.group_info.imgs.length"
                          class="gallery-icon">
                    {{ $t('Gallery') }}</span>
                  </div>
                  <div class="group-introduction">
                    <p class="group-name"><span>{{ group.group_info.group_name }}</span></p>
                    <p class="cms-style" v-html="group.group_info.desc"></p>
                    <div class="group-trait" v-if="0">
                      <p>{{ $t('Premium Suite') }}</p>
                      <ul>
                        <li v-for="(installation,installIndex) of group.group_info.installations" :key="installIndex">
                          {{ installation }}
                        </li>
                      </ul>
                    </div>
                    <span class="lowest" @click="viewAll($event,groupIndex)"
                          v-html="$t('From avg. {s} per night',{s:`<span>${formatMoney(group.group_info.lower,$t(currency))}</span>`})"></span>
                  </div>
                  <div class=view-all @click="viewAll($event,groupIndex)">{{ $t('View All') }} »</div>
                </div>
              </template>
              <div class="room-types">
                <ul>
                  <template v-for="(type,typeIndex) of group.room_type">
                    <li :key="typeIndex" v-if="!isRoomInventoryFull(type, rateKey)">
                      <div class="img-content" v-if="type.img">
                        <img :src="type.img" alt="room image">
                      </div>

                      <div class="texts">
                        <strong>{{ type.name }}</strong>
                        <p>{{ $t('{s} per night', {s: formatMoney(type.TotalPrice, $t(currency))}) }}</p>
                      </div>
                      <el-button
                        :disabled="isEdit"
                        type="primary"
                        :class="{selected:type===group.activeRoom}"
                        @click="select(type,{groupKey,rateKey})"
                        v-text="type===group.activeRoom?$t('SELECTED'):$t('SELECT')"/>
                    </li>
                  </template>
                </ul>

              </div>
              <div class="trip" v-if="group.selects.length" :id="groupKey+rateKey">
                <p>{{ $t('Upgrade your trip') }}!</p>

                <div class="shuffling">
                  <el-carousel arrow="always" :autoplay="false" indicator-position="none">
                    <el-carousel-item v-for="(page,pageIndex) in Math.ceil(group.selects.length/shufflingQty )"
                                      :key="pageIndex">
                      <div class="page" :index="pageIndex">
                        <div class="additional-item"
                             v-for="(additional,addIndex) of group.selects.slice(pageIndex*shufflingQty,(pageIndex+1)*shufflingQty)"
                             :key="addIndex">
                          <div class="additional-img">
                            <img :src="additional.image" alt="additional image">
                          </div>
                          <span class="additional-name">{{ additional.name }}</span>
                          <div class="price-box">
                            <span class="price">+ {{ additional.average_price | formatMoney($t(currency)) }}</span> /
                            {{ additional.unit }}
                          </div>
                          <div class="additional-action">
                            <select v-model="additional.qty">
                              <option value="0">- {{ $t('Please Select') }} -</option>
                              <option :value="n" v-for="n of 7" :key="n">{{ n }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>

                  <div class="actions">
                    <el-button type="primary" class="action-add"
                               @click="addPackage(group.selects,group.activeRoom,rateKey)">
                      {{ $t('ADD') }}
                    </el-button>
                    <el-button
                      type="primary"
                      class="action-no" plain
                      @click="addToCart(group.activeRoom,rateKey)">
                      {{ $t('NO THANKS!') }}
                    </el-button>
                  </div>

                </div>

              </div>

              </el-collapse-item>
            </template>
          </el-collapse>
          </li>
        </template>
      </ul>
    </div>
    <p class="tips">* {{ $t('Display currencies are for reference only') }}.</p>
    <silk-popup :show="gallery" @popup-close="gallery=false" class="img-popup">
      <img-view :images="gallery" :text="galleryText" :content="galleryContent" v-if="gallery"/>
    </silk-popup>

    <silk-popup :show="policy" @popup-close="policy=''" class="policy-popup">
      <span class="popup-title">{{ $t('Cancellation Policy') }}</span>
      <div class="policy-content cms-style" v-html="policy"></div>
    </silk-popup>

  </div>
</template>

<script>
import StepBreadcrumb from '@/components/StepBreadcrumb.vue'
import AdvanceSearch from '@/components/AdvanceSearch.vue'
import ImgView from '@/components/ImgView.vue'
import {mapState} from 'vuex'
import util from '@/util'

export default {
  data: function () {
    return {
      hotel_info: '',
      room_info: [],
      selects: [],
      fullLoading: false,
      gallery: '',
      galleryText: '',
      galleryContent: '',
      collapse: [],
      isEdit: false,
      shufflingQty: 5,
      policy: '',
      grandTotal: 0,
      isAllExist: true,
    }
  },
  methods: {
    getRoomInfo() {
      this.fullLoading = true
      const other = {
        group_by: this.group_by,
        rate: this.$route.query.rate,
        roomgroup: this.$route.query.roomgroup
      }
      this.axios.get('/api/group/room/info', {
        params: Object.assign({}, this.$route.query, other)
      }).then(
        (res) => {
          if (res.code === 200) {
            this.hotel_info = res.data.hotel_info;
            this.selects = []
            let temp = res.data.room_info;
            if (!Object.keys(temp).length) {
              this.$alert(this.$t('no-room content'), this.$t('no-room title'), {
                confirmButtonText: this.$t('BACK'),
                center: true,
                // closeOnClickModal: true
              }).then(() => {
                this.$router.push({name: 'Home'})
              });
            } else {
              if (this.group_by === 'rate') {
                Object.keys(temp).forEach((rate, rateIndex) => {
                  if (rateIndex === 0) {
                    this.collapse.push([0])
                  }
                  Object.keys(temp[rate].group).forEach((group) => {
                    temp[rate].group[group].selects = []
                    temp[rate].group[group].activeRoom = ''
                    temp[rate].group[group].room_type.map((item, index) => {
                      temp[rate].group[group].room_type[index].RoomTypeCate = temp[rate].group[group].group_info.group_name
                    })
                  })
                });
              } else {
                this.collapse = [0]
                Object.keys(temp).forEach((group) => {
                  Object.keys(temp[group].rate).forEach((rate) => {
                    temp[group].rate[rate].selects = []
                    temp[group].rate[rate].activeRoom = ''
                    temp[group].rate[rate].room_type.map((item, index) => {
                      temp[group].rate[rate].room_type[index].RoomTypeCate = temp[group].group_name
                    })
                  })
                });
              }
              this.room_info = temp;
              // 如果有selects, 先匹配房间，再初始化已选房间信息
              if(localStorage.selects) {
                // 匹配房间
                this.matchRoom(this.group_by, this.room_info)
                // 初始化房间
                this.initRoom(this.group_by, this.room_info)
                // 不是全部selects都存在
                if(!this.isAllExist) {
                  this.$alert(this.$t('room unavailable content'), this.$t('room unavailable title'), {
                        confirmButtonText: this.$t('EDIT BOOKING'),
                        center: true
                  })
                }
              }
            }
          } else {
            this.$alert(res.msg, {
              confirmButtonText: this.$t('BACK'),
              center: true,
              // closeOnClickModal: true
            }).then(() => {
              this.$router.push({name: 'Home'})
            });
          }
        }
      ).finally(() => {
        this.fullLoading = false
      })
    },
    matchRoom(groupBy, roomInfo) {
      let currentSelects = JSON.parse(localStorage.selects)
      if(currentSelects.length > 0) {
        let GroupByCodeList = []
        let existSelects = []
        Object.keys(roomInfo).forEach((key)=>{
          let group = {}
          if(groupBy === 'rate') {
            group = roomInfo[key].group
          } else {
            group = roomInfo[key].rate
          }
          Object.keys(group).forEach((groupKey) => {
            let roomType = group[groupKey].room_type
            roomType.map((roomItem) => {
              if(groupBy === 'rate') {
                GroupByCodeList.push(roomItem.code + ':' + key)
              } else {
                GroupByCodeList.push(roomItem.code + ':' + groupKey)
              }
            })
          })
        })
        currentSelects.forEach((selectValue, index)=>{
          existSelects.push(false)
          for(let i = 0; i < GroupByCodeList.length; i++) {
            if(selectValue == GroupByCodeList[i]) {
              existSelects[index] = true
            }
          }
        })
        existSelects.forEach((value, index) => {
          if(value == false) {
            this.isAllExist = false
            currentSelects.splice(index, 1)
          }
        })
        localStorage.selects = JSON.stringify(currentSelects)
      }
    },
    initRoom(groupBy, roomInfo) {
      let currentSelects = JSON.parse(localStorage.selects)
      let rateKey = ""
      let category = {}
      let rooms = {}
      currentSelects.forEach((select) => {
        Object.keys(roomInfo).forEach((roomKey) => {
          if(groupBy === 'rate') {
            category = roomInfo[roomKey].group
          } else {
            category = roomInfo[roomKey].rate
          }
          Object.keys(category).forEach((cateKey) => {
            if(groupBy === 'rate') {
              rateKey = roomKey
            } else {
              rateKey = cateKey
            }
            rooms = category[cateKey].room_type
            rooms.forEach((value) => {
              if(value.code + ':' + rateKey == select) {
                this.addToCart(value, rateKey)
              }
            })
          })
        })
      })
    },
    groupBy(type) {
      const other = {
        group_by: type
      }
      const query = Object.assign({}, this.$route.query, other)
      this.$router.push({
        'name': 'SelectRoom', query
      })
    },
    edit() {

      if (!this.selects.length) {
        this.isEdit = true
      } else {
        this.$confirm(this.$t('This action will delete the selected room. Do you want to continue?'), this.$t('Warning'), {
          confirmButtonText: this.$t('Continue'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning'
        }).then(() => {
          this.isEdit = true
          this.selects = []
          localStorage.removeItem('selects')
        }).catch(() => {
        });
      }
    },
    select(room, path) {
      const data = {
        rate_code: path.rateKey,
        arrival: this.hotel_info.arrival_date,
        departure: this.hotel_info.departure_date,
        hotel_code: this.hotel_info.code,
      }
      this.fullLoading = true
      this.axios.get('/api/group/info/packages', {
        params: data
      }).then(
        (res) => {
          if (res.code === 200) {
            if (!res.data.length) {
              //如果没有数据，直接加入购物车
              this.addToCart(room, path.rateKey)
            } else {
              if (this.group_by === 'rate') {
                this.room_info[path.rateKey].group[path.groupKey].selects = res.data
                this.room_info[path.rateKey].group[path.groupKey].activeRoom = room
              } else {
                this.room_info[path.groupKey].rate[path.rateKey].selects = res.data
                this.room_info[path.groupKey].rate[path.rateKey].activeRoom = room
              }
              this.$nextTick(() => {
                const top = document.getElementById(path.groupKey + path.rateKey).offsetTop
                window.scrollTo({
                  top,
                  behavior: "smooth"
                });
              })
            }
          }
        }
      ).finally(() => {
        this.fullLoading = false
      })
    },
    addToCart(room, rate_code, selects = []) {
      const obj = Object.assign(room, {rate_code, selects})
      this.selects.push(obj)
      // 存储select信息
      this.addToStorage(this.selects)

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    addPackage(selects, room, rate_code) {
      const arr = selects.filter((select) => select.qty)
      this.addToCart(room, rate_code, arr)
    },
    hasAvailableRooms(roomTypes, rateCode) {
      const types = Array.isArray(roomTypes) ? roomTypes : []

      return types.some((room) => !this.isRoomInventoryFull(room, rateCode))
    },
    hasAvailableCategoryGroup(group) {
      return Object.keys(group.rate || {}).some((rateCode) => {
        return this.hasAvailableRooms(group.rate[rateCode].room_type, rateCode)
      })
    },
    hasAvailableRate(rate, rateCode) {
      return Object.keys(rate.group || {}).some((groupKey) => {
        return this.hasAvailableRateGroup(rate.group[groupKey], rateCode)
      })
    },
    hasAvailableRateGroup(group, rateCode) {
      return this.hasAvailableRooms(group.room_type, rateCode)
    },
    isRoomInventoryFull(room, rateCode) {
      const inventory = Number(room.inventory)

      if (isNaN(inventory)) {
        return false
      }

      const selectedQty = this.selects.filter((select) => {
        return select.code === room.code && select.rate_code === rateCode
      }).length

      return selectedQty >= inventory
    },
    checkout() {
      //是否满足结算条件
      if (this.selects.length >= 1) {
        localStorage.removeItem("form");
        localStorage.setItem("room", this.hotel_info.rooms)
        let query = Object.assign({submit: this.actions}, this.$route.query)
        this.$router.push({
          'name': 'Payment', query
        })
      }
    },
    addRoom() {
      // 顶部房间数+1
      this.hotel_info.rooms = Number(this.hotel_info.rooms) + 1
      this.$route.query.rooms = this.hotel_info.rooms
      this.getRoomInfo()
    },
    // selects加入localStorage
    addToStorage(selects) {
      let storageSelect = []
      selects.map(item => {
        storageSelect.push(item.code+ ':' +item.rate_code)
      })
      localStorage.setItem('selects', JSON.stringify(storageSelect))
    },
    remove(index) {
      this.selects.splice(index, 1)
      // 存储select信息
      this.addToStorage(this.selects)
      // 判断房间数量，并相应减少
      if(this.hotel_info.rooms >= 2) {
        this.hotel_info.rooms -= 1
        this.$route.query.rooms = this.hotel_info.rooms
      }
      this.getRoomInfo()
    },
    getNum: util.getNum,
    showGallery(img, galleryText, galleryContent) {
      this.gallery = img.map((x) => x.url)
      this.galleryText = galleryText
      this.galleryContent = galleryContent
    },
    gaEvent() {
      const dayLong = (util.dateArr(this.$route.query.departure_date) - util.dateArr(this.$route.query.arrival_date)) / util.DAY
      let gaData = {
        currentTimeMacau: localStorage.date || '',
        currentTimeLocal: util.dateStr(new Date(), true),
        currentStep: 2,
        cookieId: '',
        memberLoggedIn: false,
        //step2 data
        checkInDate: this.$route.query.arrival_date,
        checkOutDate: this.$route.query.departure_date,
        selectedHotel: this.$route.query.hotel_code,
        numberTotalRooms: this.$route.query.rooms,
        numberTotalAdults: this.$route.query.adults,
        numberTotalChild: this.$route.query.children,
        numberTotalNights: dayLong,
      }

      window.dataLayer.push(gaData)
      window._mtm.push({"event": "booking data ready"})
    },
    viewAll(event) {
      event.currentTarget.offsetParent.parentNode.click()
    },
    showPolicy(html) {
      let police = ''
      Object.keys(html).forEach((key) => police += html[key])
      this.policy = police
    }
  },
  created() {
    //this.$root.$children[0].gaInit()
    this.getRoomInfo()
    window.onresize = () => {
      if (window.innerWidth < 600) {
        this.shufflingQty = 2
      } else if (window.innerWidth < 800) {
        this.shufflingQty = 3
      } else if (window.innerWidth < 1100) {
        this.shufflingQty = 4
      } else {
        this.shufflingQty = 5
      }
    }
    if (this.dataLayerReady) {
      this.gaEvent()
    }
    if(this.$route.query.clear === 'y') {
      localStorage.removeItem("selects")
      delete this.$route.query.clear
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      urlParams.delete("clear");
      history.replaceState('', '', location.pathname + '?' + urlParams.toString());
    }
  },
  components: {
    StepBreadcrumb,
    AdvanceSearch,
    ImgView
  },
  computed: {
    ...mapState(
      ['SearchParams', 'currency', 'dataLayerReady', 'gaData']
    ),
    totals() {
      let rooms = this.selects;
      let arr = []
      let grandTotal = 0
      rooms.forEach((room) => {
        let roomTotals = []
        //房间价格
        roomTotals[0] = util.getNum(room.TotalPrice) * this.hotel_info.day_number;
        //package价格
        room.selects.forEach((select) => {
          roomTotals.push(
            select.qty * select.average_price
          )
        })
        //总价
        let total = 0
        roomTotals.forEach((price) => {
          total += price
        })
        roomTotals.push(total)
        grandTotal += total
        arr.push(roomTotals)
        this.grandTotal = grandTotal
      })
      return arr
    },
    actions() {
      let str = ''
      this.selects.forEach((room, roomIndex) => {
        let roomStr = room.code + ':' + room.rate_code
        if (room.selects.length) {
          roomStr += '!!'
          room.selects.forEach((select, selectIndex) => {
            roomStr += select.code + ':' + select.qty
            if (selectIndex !== room.selects.length - 1) {
              roomStr += '!'
            }
          })
        }
        if (roomIndex !== this.selects.length - 1) {
          roomStr += ','
        }
        str += roomStr
      })
      return str
    },
    group_by() {
      return this.$route.query.group_by || 'cate'
    }
  },
  watch: {
    dataLayerReady(isReady) {
      if (isReady) {
        this.gaEvent()
      }
    }
  }
}

</script>
